import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

/**
 *  GlobeAlert Component.
 */
class GlobeAlert extends React.Component {
  /**
   *  Render the compon0ent
   */

  constructor(props) {
    super(props)
    this.myRef = React.createRef()
    this.handleClick = this.handleClick.bind(this)
    this.state = {
      animationAction: false,
    }
  }

  componentDidMount() {
    let canvas = document.getElementById('main-canvas')
    canvas && canvas.addEventListener('mousedown', this.handleClick)
  }

  componentWillUnmount() {
    let canvas = document.getElementById('main-canvas')
    canvas && canvas.removeEventListener('mousedown', this.handleClick)
  }

  handleClick(e) {
    if (this.myRef && !this.myRef.contains(e.target)) {
      this.setState({
        animationAction: true,
      })

      setTimeout(() => {
        this.setState({
          animationAction: false,
        })
      }, 1500)
    }
  }

  render() {
    const { icon, label, style, animation } = this.props
    const { animationAction } = this.state

    if (!label) {
      return null
    }

    return (
      <div className="alert--mars__position">
        <div
          ref={(elem) => (this.myRef = elem)}
          className={'alert--mars ' + (animationAction ? (animation ? animation : '') : '')}
          style={{ style }}
        >
          {icon ? <span className={icon}> </span> : null}
          <FormattedMessage id={label} />
        </div>
      </div>
    )
  }
}

GlobeAlert.propTypes = {
  icon: PropTypes.string,
  label: PropTypes.string,
  animation: PropTypes.string,
  style: PropTypes.object,
}

export default GlobeAlert
